import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { RequestApprovalButton,
    ApprovalRequestedButton,
    ApproveOrReviseButtons,
    ApprovalGranted } from '../ApprovalButtons';

const useStyles = makeStyles(() => ({
    content: {
        textAlign: 'center'
    }
}));

export function getReturnToPriorPhaseBtn(approvalUrl, onSuccess) {
    return <RequestApprovalButton
      approvalUrl={approvalUrl.href}
      onSuccess={onSuccess}
      padding='small'
      buttonText={'RETURN TO PRIOR PHASE'}
    />;
}

export function getValuesApprovalBtn(initiative, refreshValues) {
    if (initiative._links['VALUE_WSL_APPROVAL']) {
        return <ApproveOrReviseButtons
          approvalUrl={initiative._links['VALUE_WSL_APPROVAL'].href}
          onSuccess={refreshValues}
        />
    }
    if (initiative._links['VALUE_FINANCE_APPROVAL']) {
        return <ApproveOrReviseButtons
          approvalUrl={initiative._links['VALUE_FINANCE_APPROVAL'].href}
          onSuccess={refreshValues}
        />
    }
    if (initiative._links['VALUE_TO_APPROVAL']) {
        return <ApproveOrReviseButtons
          approvalUrl={initiative._links['VALUE_TO_APPROVAL'].href}
          onSuccess={refreshValues}
        />
    }
    if (initiative._links['VALUE_REQUEST_APPROVAL']) {
        return <RequestApprovalButton
          approvalUrl={initiative._links['VALUE_REQUEST_APPROVAL'].href}
          onSuccess={refreshValues}
        />;
    }
}

export function getKPIApprovalBtn(initiative, refreshValues) {
    if (initiative._links['KPI_WSL_APPROVAL']) {
        return <ApproveOrReviseButtons
          approvalUrl={initiative._links['KPI_WSL_APPROVAL'].href}
          onSuccess={refreshValues}
        />
    }
    if (initiative._links['KPI_REQUEST_APPROVAL']) {
        return <RequestApprovalButton
          approvalUrl={initiative._links['KPI_REQUEST_APPROVAL'].href}
          onSuccess={refreshValues}
        />;
    }
}

export function getMilestonePlanApprovalBtn(hasMoneyStep, initiative, fetchInitiative)  {
    if (!hasMoneyStep) {
        return;
    }

    if (initiative._links['MILESTONE_WSL_APPROVAL']) {
        return <ApproveOrReviseButtons
          approvalUrl={initiative._links['MILESTONE_WSL_APPROVAL'].href}
          onSuccess={fetchInitiative}
        />
    }
    if (initiative._links['MILESTONE_REQUEST_APPROVAL']) {
        return <RequestApprovalButton
          approvalUrl={initiative._links['MILESTONE_REQUEST_APPROVAL'].href}
          onSuccess={fetchInitiative}
        />;
    }
    if ((initiative.milestone_request_user != null)) {
        return (initiative.milestone_wsl_user == null) ?
          <ApprovalRequestedButton/> :
          <ApprovalGranted
            approverNames={[initiative.milestone_wsl_user]}
          />;
    }
};

export default function LxApprovalButtons({ initiative, onSuccess, level, buttonText = 'SUBMIT FOR VALIDATION'}) {
    let lowercaseLevel = level.toLowerCase();
    const classes = useStyles();

    const getBottomBtn = () => {
        if (initiative._links[`${level}_SPONSOR_APPROVAL`]) {
            return <ApproveOrReviseButtons
                approvalUrl={initiative._links[`${level}_SPONSOR_APPROVAL`].href}
                onSuccess={onSuccess}
                padding='small'
            />
        }
        if (initiative._links[`${level}_TO_APPROVAL`]) {
            return <ApproveOrReviseButtons
                approvalUrl={initiative._links[`${level}_TO_APPROVAL`].href}
                onSuccess={onSuccess}
                padding='small'
            />
        }
        if (initiative._links[`${level}_REQUEST_APPROVAL`]) {
            return <RequestApprovalButton
                approvalUrl={initiative._links[`${level}_REQUEST_APPROVAL`].href}
                onSuccess={onSuccess}
                padding='small'
                buttonText={buttonText}
            />;
        }
        if (initiative[`${lowercaseLevel}_request_user`] != null) {
            const approvers = [];
            const missingApprovers = [];
            initiative[`${lowercaseLevel}_sponsor_user`] ? approvers.push(initiative[`${lowercaseLevel}_sponsor_user`]) : missingApprovers.push('Sponsor');
            // Embed Approval always requires the TO
            if ((initiative.requiresGreaterApproval || level === 'EMBED') && level !== 'BUILD') {
                initiative[`${lowercaseLevel}_to_user`] ? approvers.push(initiative[`${lowercaseLevel}_to_user`]) : missingApprovers.push('TO');
            }

            return ((initiative[`${lowercaseLevel}_sponsor_user`] == null) && (initiative[`${lowercaseLevel}_to_user`] == null)) ?
                <ApprovalRequestedButton padding='small' /> :
                <ApprovalGranted
                    approvalType={level}
                    approverNames={approvers}
                    missingApprovers={missingApprovers}
                    padding='small'
                />;
        }
    }

    return (
        <div className={classes.content}>
            { getBottomBtn() }
        </div>
    );
}
